/**
 * abilityVfxCaitlyn — Caitlyn Q/W/E/R rifle silhouettes (SPY-410).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildPiltoverPeacemaker(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1);
  const steel = mat(THREE, spec.color || 0x94a3b8);
  const brass = mat(THREE, 0xcbd5e1, 0.85);
  const barrel = new THREE.Mesh(
    new THREE.CylinderGeometry(0.07 * s, 0.1 * s, 1.4 * s, 8).rotateX(Math.PI / 2),
    steel
  );
  barrel.position.y = 0.45 * s;
  group.add(barrel);
  const muzzle = new THREE.Mesh(new THREE.ConeGeometry(0.16 * s, 0.35 * s, 6).rotateX(Math.PI / 2), brass);
  muzzle.position.set(0, 0.45 * s, 0.8 * s);
  group.add(muzzle);
  const stock = new THREE.Mesh(new THREE.BoxGeometry(0.12 * s, 0.18 * s, 0.35 * s), steel);
  stock.position.set(0, 0.4 * s, -0.7 * s);
  group.add(stock);
  group.userData = { shape: 'piltover_peacemaker' };
  return group;
}

export function buildYordleSnapTrap(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.4);
  const amber = mat(THREE, spec.color || 0xf59e0b, 0.88);
  const rim = mat(THREE, 0xfde68a, 0.8);
  const disc = new THREE.Mesh(
    new THREE.CylinderGeometry(0.4 * s, 0.4 * s, 0.08 * s, 16),
    amber
  );
  disc.position.y = 0.06;
  group.add(disc);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.65 * s, 20).rotateX(-Math.PI / 2),
    rim
  );
  ring.position.y = 0.1;
  group.add(ring);
  const spike = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.35 * s, 6), amber);
  spike.position.y = 0.35 * s;
  group.add(spike);
  group.userData = { shape: 'yordle_snap_trap' };
  return group;
}

export function buildCaliberNet(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const slate = mat(THREE, spec.color || 0x64748b);
  const cord = mat(THREE, 0x94a3b8, 0.85);
  const body = new THREE.Mesh(new THREE.SphereGeometry(0.22 * s, 10, 10), slate);
  body.position.y = 0.45 * s;
  group.add(body);
  const mesh = new THREE.Mesh(
    new THREE.TorusGeometry(0.32 * s, 0.04 * s, 8, 16),
    cord
  );
  mesh.rotation.x = Math.PI / 2;
  mesh.position.y = 0.45 * s;
  group.add(mesh);
  const trail = new THREE.Mesh(
    new THREE.CylinderGeometry(0.04 * s, 0.06 * s, 0.7 * s, 6).rotateX(Math.PI / 2),
    cord
  );
  trail.position.set(0, 0.45 * s, -0.45 * s);
  group.add(trail);
  group.userData = { shape: 'caliber_net' };
  return group;
}

export function buildAceInTheHole(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.8 * (spec.scale || 1.55);
  const crimson = mat(THREE, spec.color || 0xef4444, 0.9);
  const sight = mat(THREE, 0xfca5a5, 0.85);
  const scope = new THREE.Mesh(new THREE.CylinderGeometry(0.18 * s, 0.18 * s, 0.9 * s, 10), crimson);
  scope.position.y = 0.7 * s;
  group.add(scope);
  const lens = new THREE.Mesh(new THREE.TorusGeometry(0.28 * s, 0.05 * s, 8, 16), sight);
  lens.rotation.x = Math.PI / 2;
  lens.position.y = 1.05 * s;
  group.add(lens);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.3 * s, 0.7 * s, 20).rotateX(-Math.PI / 2),
    crimson
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'ace_in_the_hole' };
  return group;
}
